import { useEffect } from 'react';

// Tracks the cursor over elements matching `selector` and writes its
// position into CSS vars (--mx, --my) so cards can render a spotlight
// gradient that follows the mouse.
export default function useSpotlight(selector) {
  useEffect(() => {
    const els = document.querySelectorAll(selector);
    if (!els.length) return;

    const handlers = [];
    els.forEach((el) => {
      const onMove = (e) => {
        const rect = el.getBoundingClientRect();
        el.style.setProperty('--mx', `${e.clientX - rect.left}px`);
        el.style.setProperty('--my', `${e.clientY - rect.top}px`);
      };
      el.addEventListener('mousemove', onMove);
      handlers.push([el, onMove]);
    });

    return () => handlers.forEach(([el, fn]) => el.removeEventListener('mousemove', fn));
  }, [selector]);
}
